/* AM-SIZE-CHART v3 - guia de tallas propia (metafield custom.am_size_chart).
   Datos: <script type="application/json" id="am-sc-data"> que pinta snippets/am-size-chart.liquid.
   - Inyecta "SIZE GUIDE" en la etiqueta "Size:" del selector (misma posicion que SmartSize).
   - Ventana lateral con toggle cm / in (conversion automatica en las columnas con convert:true).
   - Eventos por delegacion en document + MutationObserver (el tema re-renderiza el selector). */
(function () {
  if (window.__amSizeChart) return;
  window.__amSizeChart = true;

  var data = null;
  try { data = JSON.parse(document.getElementById('am-sc-data').textContent); } catch (e) { return; }
  if (!data || !data.columns || !data.rows || !data.rows.length) return;

  var unit = 'in';
  try { unit = localStorage.getItem('amScUnit') || 'in'; } catch (e) {}
  var src = (data.unit || 'cm').toLowerCase();

  document.documentElement.classList.add('am-sc-on');

  function conv(v) {
    if (unit === src) return v;
    var f = (src === 'cm') ? 1 / 2.54 : 2.54;
    return String(v).replace(/\d+(?:\.\d+)?/g, function (n) { return (parseFloat(n) * f).toFixed(1).replace(/\.0$/, ''); });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function hasConvertible() {
    for (var i = 0; i < data.columns.length; i++) if (data.columns[i].convert) return true;
    return false;
  }

  function tableHtml() {
    var h = '<table class="am-sc-table' + (data.columns.length >= 6 ? ' am-sc-wide' : '') + '"><thead><tr>';
    data.columns.forEach(function (c) { h += '<th>' + esc(c.label) + '</th>'; });
    h += '</tr></thead><tbody>';
    data.rows.forEach(function (r) {
      h += '<tr>';
      r.forEach(function (v, j) {
        var c = data.columns[j] || {};
        h += '<td>' + esc(c.convert ? conv(v) : v) + '</td>';
      });
      h += '</tr>';
    });
    return h + '</tbody></table>';
  }

  function render() {
    var m = document.getElementById('am-sc-modal');
    if (!m) return;
    m.querySelector('.am-sc-tablewrap').innerHTML = tableHtml();
    var bs = m.querySelectorAll('[data-am-sc-unit]');
    for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('is-active', bs[i].getAttribute('data-am-sc-unit') === unit);
  }

  function build() {
    var m = document.getElementById('am-sc-modal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'am-sc-modal';
    m.className = 'am-sc-overlay';
    m.setAttribute('aria-hidden', 'true');
    var bulb = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.2 1 2V17h6v-.3c0-.8.4-1.5 1-2A7 7 0 0 0 12 2z"/></svg>';
    m.innerHTML =
      '<div class="am-sc-panel" role="dialog" aria-modal="true" aria-label="' + esc(data.title || 'Size Chart') + '">' +
        '<button type="button" class="am-sc-close" data-am-sc-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="am-sc-body">' +
          '<h2 class="am-sc-title">' + esc(data.title || 'Size Chart') + '</h2>' +
          (hasConvertible() ? '<div class="am-sc-units"><div class="am-sc-toggle">' +
            '<button type="button" data-am-sc-unit="cm">cm</button><button type="button" data-am-sc-unit="in">in</button>' +
          '</div></div>' : '') +
          '<div class="am-sc-tablewrap"></div>' +
          (data.note ? '<div class="am-sc-note">' + bulb + '<span>' + esc(data.note) + '</span></div>' : '') +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    return m;
  }

  function open() {
    var m = build();
    render();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('am-sc-lock');
  }

  function close() {
    var m = document.getElementById('am-sc-modal');
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('am-sc-lock');
  }

  function place() {
    var legends = document.querySelectorAll('legend.name-option, legend.form__label');
    for (var i = 0; i < legends.length; i++) {
      var lg = legends[i];
      if (!/^\s*size\b/i.test(lg.textContent)) continue;
      if (lg.querySelector('.am-sc-triggers')) continue;
      var w = document.createElement('div');
      w.className = 'am-sc-triggers';
      w.innerHTML = '<button type="button" class="am-sc-trigger" data-am-sc-open>SIZE GUIDE</button>';
      lg.classList.add('am-sc-legend');
      lg.appendChild(w);
    }
    // barra fija de compra (am-sticky-atc): su enlace "Size Guide" abre esta guia, no la de SmartSize
    var sl = document.querySelector('.am-satc__link');
    if (sl && sl.hidden) sl.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-am-sc-open], .am-satc__link')) { e.preventDefault(); e.stopPropagation(); open(); return; }
    var u = t.closest('[data-am-sc-unit]');
    if (u) {
      unit = u.getAttribute('data-am-sc-unit');
      try { localStorage.setItem('amScUnit', unit); } catch (err) {}
      render();
      return;
    }
    if (t.closest('[data-am-sc-close]') || t.id === 'am-sc-modal') close();
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(place, 60); }
  function boot() {
    place();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', place);
})();
